// Chart palette aligned to the BidWin token system. recharts accepts any CSS
// color string for stroke/fill, so these reference the same CSS variables as the
// rest of the UI — keeping charts on-brand and theme-aware (they follow `.dark`).

export const CHART = {
  primary: 'rgb(var(--bw-primary))',
  strong: 'rgb(var(--bw-fit-strong-stroke))',
  moderate: 'rgb(var(--bw-fit-moderate-stroke))',
  weak: 'rgb(var(--bw-fit-weak-stroke))',
  neutral: 'rgb(var(--bw-muted))',
  accent: 'rgb(var(--bw-accent))',
  grid: 'rgb(var(--bw-border))',
  axis: 'rgb(var(--bw-muted))',
} as const;

// Default categorical series order.
export const CHART_SERIES = [
  CHART.primary,
  CHART.strong,
  CHART.moderate,
  CHART.neutral,
  CHART.accent,
];
